import type { NavItem } from './types';
import {
  IconHome,
  IconCatalog,
  IconPrescription,
  IconCart,
  IconProfile,
} from '@/shared/ui/icons';

export const NAV_ITEMS: NavItem[] = [
  { path: '/home', label: 'Главная', icon: IconHome },
  { path: '/catalog', label: 'Каталог', icon: IconCatalog },
  { path: '/prescriptions', label: 'Рецепты', icon: IconPrescription },
  { path: '/cart', label: 'Корзина', icon: IconCart },
  { path: '/profile', label: 'Профиль', icon: IconProfile },
];
